import React, { useState, useEffect, useContext } from 'react'
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import api from '../../services/api';
import { MarkContext } from '../../context/mark';
const TextAreaPage = ({ description,type,id }) => {
    

    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    const handleEditorChange = (newEditorState) => {
        setEditorState(newEditorState);
        const rawContentState = convertToRaw(newEditorState.getCurrentContent());
        const content = JSON.stringify(rawContentState);
        localStorage.setItem("@CONTENT_DESCRIPTION_PAGE", content);
    };
    const handleUpdate = async (field, value,id,type_page) => {

        if (type == "update") {
            try {

                const update = await api.put("/pages/update",{
                    type_page:localStorage.getItem("@ID_SELECT_PAGES") == "Quem Somos" ? 1 : localStorage.getItem("@ID_SELECT_PAGES") == "Política de Privacidade" ? 2 : localStorage.getItem("@ID_SELECT_PAGES") == "Formas de Pagamento" ? 3 : 4 ,
                    description:value
                })

                // const response = await api.put("panel/product/update", {
                //     field,
                //     value,
                //     id: id
                // });

                // if (response.status === 200) {
                //     // Sucesso na atualização
                //     console.log("Produto atualizado com sucesso:", response.data);
                // } else {
                //     // Tratamento de erro
                //     console.error("Erro ao atualizar o produto:", response.data);
                // }
            } catch (error) {
                // Tratamento de erro
                console.error("Erro ao atualizar o produto:", error);
            }
        }


    };

    useEffect(() => {
        
            try {
                const contentState = convertFromRaw(JSON.parse(description));
                setEditorState(EditorState.createWithContent(contentState));
            } catch (error) {
                console.error("Failed to load content from description", error);
            }
        
    }, [description]);




    return (
        <Editor
            editorState={editorState}
            // onBlur={() => handleUpdate("description",localStorage.getItem("@CONTENT_DESCRIPTION_PAGE"),id)}

            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={handleEditorChange}
            editorStyle={{ height: "220px", paddingLeft: "28px", border: "1px solid #D7D7D7", borderRadius: "5px" }}
        />
    )
}

export default TextAreaPage